<template>
  <div>
    <div style="margin-top: 8px; margin-left: 8px">
      <el-button @click="search(1)"> 查询 </el-button>
      <el-button @click="modals"> 添加战区/片区 </el-button>
    </div>
    <el-descriptions
      style="margin-top: 8px; margin-left: 8px"
      :column="2"
      size="mini"
      border
    >
      <el-descriptions-item label="名称">
        <el-input
          size="mini"
          v-model="searchForm.keyword"
          placeholder="输入战区/片区名称搜索"
        ></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="类型">
        <el-select
          v-model="searchForm.type"
          placeholder="请选择战区类型"
          :clearable="true"
          size="mini"
        >
          <el-option label="战区" :value="1"></el-option>
          <el-option label="片区" :value="2"></el-option>
        </el-select>
      </el-descriptions-item>
    </el-descriptions>
    <el-table
      style="margin-top: 8px; margin-left: 8px"
      max-height="600"
      :data="listData"
      border
    >
      <el-table-column label="名称" prop="name" />
      <el-table-column label="类型" prop="type" />
      <el-table-column label="片区数量" prop="sonCount" />
      <el-table-column label="分类" prop="class">
        <template #default="data">
          {{ class_select[data.row.class].label }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="data">
          <el-button size="mini" @click="edit(data.row.id)">修改</el-button>
          <el-button size="mini" @click="del(data.row.id)">删除</el-button>
          <el-button size="mini" @click="project(data.row)">管理项目</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="listData">
      <Page
        :total="searchForm.totalCount"
        :page-size="searchForm.pageSize"
        @on-change="search"
        show-total
      />
    </div>
    <el-dialog
      title="添加战区/片区"
      :visible.sync="modal"
      width="60%" v-loading="form_loading"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="分类" prop="class">
          <el-select v-model="form.class" size="small" collapse-tags placeholder="请选择分类">
            <el-option
              v-for="item in class_select"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :clearable="false"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.type" placeholder="请选择战区类型">
            <el-option label="战区" :value="1"></el-option>
            <el-option label="片区" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="归属战区" v-if="form.type == 2" prop="pid">
          <el-select v-model="form.pid" placeholder="请选择战区">
            <el-option
              v-for="item in pidSelect"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="归属劳务公司">
          <el-cascader style="width: 100%;"
                       v-model="form.work_company_id"
                       placeholder="请选择"
                       :options="workCompanyList"
                       :props="{ checkStrictly: true, label:'WorkCompanyName', value:'ID', children:'children' }"
                       filterable>
          </el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveZone">保存</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="绑定房产"
      :visible.sync="pindexModal"
      width="60%"
      :before-close="handleFromClose"
    >
      <el-form :model="pindexFrom" label-width="80px">
        <el-form-item label="项目">
          <el-tree
            :data="pindexList"
            :props="{ label: 'name', children: 'id' }"
            node-key="id"
            show-checkbox
            ref="tree"
            :default-checked-keys="defaultCheckedKeys"
          >
          </el-tree>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveProject">保存</el-button>
          <el-button @click="handleFromClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Http from "../Oa/common/Http";
export default {
  name: "ZoneManage",
  data() {
    return {
      modal: false,
      listData: [],
      searchForm: {
        type: "",
        keyword: "",
        page: 1,
        pagesize: 10,
        totalCount: 0,
      },
      form: {
        id: "",
        name: "",
        type: 1,
        pid: "",
        work_company_id : 0,
      },
      form_loading : false ,
      pindexFrom: {
        id: "",
        pindex_ids: [],
      },
      pindexList: [],
      pidSelect: [],
      pindexModal: false,
      rules: {
        name: [
          { required: true, message: "请填写战区/片区名称", trigger: "blur" },
        ],
        class: [
          { required: true, message: "请选择分类", trigger: "blur" },
        ],
        pid: [{ required: true, message: "请选择归属战区", trigger: "blur" }],
      },
      defaultCheckedKeys: [],
      class_select: [
        {
          value: 0,
          label: "无",
        },
        {
          value: 1,
          label: "一级",
        },
        {
          value: 2,
          label: "二级",
        },
        {
          value: 3,
          label: "三级",
        },
        {
          value: 4,
          label: "四级",
        },
      ],
      workCompanyList : [],
    };
  },
  mounted() {
    this.search(1);
    this.pindex();
    this.getWorkCompanyList();
  },
  methods: {
    getPid() {
      this.$myhttp
        .post(
          "admin/ZoneManage/getPidSelect",
          {},
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          this.pidSelect = backdata.data.data;
        });
    },
    saveZone() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$myhttp
            .post("admin/ZoneManage/saveZone", this.form, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.$message.success(backdata.data.msg);
                this.search(1);
                this.handleClose();
              } else {
                this.$message.error(backdata.data.msg);
              }
            })
            .catch((err) => {
              this.$message.error(err);
            });
        } else {
        }
      });
    },
    search(page) {
      this.searchForm.page = page;
      this.$myhttp
        .post("admin/ZoneManage/index", this.searchForm, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data;
            this.searchForm.totalCount = backdata.data.totalCount;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    modals() {
      this.form = {
        id: "",
        name: "",
        type: 1,
        pid: "",
      };
      this.modal = true;
      this.getPid();
    },
    handleClose() {
      this.modal = false;
    },
    edit(id) {
      this.modal = true;
      this.view(id);
      this.getPid();
    },
    view(id) {
      this.form_loading = true;
      let that = this;
      this.$myhttp
        .post(
          "admin/ZoneManage/view",
          { id },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.form = backdata.data.data;
            // if(backdata.data.data.work_company_id > 0){
            //   this.form.work_company_id = [backdata.data.data.work_company_id]
            // }
            this.defaultCheckedKeys =
              backdata.data.data.pindex_id.length > 0
                ? backdata.data.data.pindex_id
                : [];
            if (this.pindexModal === true) {
              this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys);
            }
          } else {
            this.$message.error(backdata.data.msg);
          }
          this.form_loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.form_loading = false;
        });
    },
    del(id) {
      this.$myhttp
        .post(
          "admin/ZoneManage/delete",
          { id },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.search(1);
            this.$message.success(backdata.data.msg);
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    project(row) {
      this.pindexModal = true;
      this.view(row.id);
      this.pindexFrom = {
        id: row.id,
        pindex_ids: [],
      };
    },
    pindex() {
      this.$myhttp
        .get("admin/common/pindex", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.pindexList = backdata.data.data.map((item) => {
              return { name: item.name, id: item.id };
            });
          } else {
            this.$message.error(backdata.data.message);
          }
        });
    },
    handleFromClose() {
      this.pindexModal = false;
    },
    saveProject() {
      var pindex_ids = this.$refs.tree.getCheckedKeys();
      this.pindexFrom.pindex_ids = pindex_ids;
      this.$myhttp
        .post("admin/ZoneManage/saveProject", this.pindexFrom, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.handleFromClose();
            this.$message.success(backdata.data.msg);
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 获取劳务公司列表
    getWorkCompanyList(){
      let that = this
      Http.get(Http.getFlowBaseURL() + "/hrm/HrLegalUnit/getAllCompanyList", {}, res => {
        if (res.code == 0) {
          that.workCompanyList = res.data
          console.log(that.workCompanyList)
        } else {
          that.workCompanyList = []
        }
      })
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/ZoneManage.vue